import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"



import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

    const PersonalDisciplinaryAndGrievances = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [isLoading, setIsLoading] = useState(false)

        const [settings, setSettings] = useState([])

        const [documentNo, setDocumentNo] = useState('')
        const [setupId, setSetupId] = useState('')
        const [description, setDescription] = useState('')
        const [reportedOn, setReportedOn] = useState([new Date()])
        const [incidentDate, setIncidentDate] = useState([new Date()])
        const [reportedBy, setReportedBy] = useState('')
        const [inditedStaff, setInditedStaff] = useState('')
        const [caseStatus, setCaseStatus] = useState('Draft')
        const [caseId, setCaseId] = useState('')

        const [sStartDate, setSStartDate] = useState([new Date(new Date().getFullYear(), 0, 1)]);
        const [sEndDate, setSEndDate] = useState([new Date(new Date().getFullYear(), 11, 31)]);
        const [sEmployeeNo, setSEmployeeNo] = useState('') 
        const [sEmployeeName, setSEmployeeName] = useState('')  
        const [sDocumentNo, setSDocumentNo] = useState('')
        const [sType, setSType] = useState('')
        const [sCategory, setSCategory] = useState('')
        const [sStatus, setSStatus] = useState('')
        
        const [cases, setCases] = useState([])
        const [userId, setUserId] = useState('')
        const [userHRId, setUserHRId] = useState('')
        const [isEdit, setIsEdit] = useState(false)
    
        const [modal_case, setmodal_case] = useState(false);

        const [selectedEmployee, setSelectedEmployee] = useState('')
        const [employeeOptions, setEmployeeOptions] = useState([])

        const [typeOptions, setTypeOptions] = useState(['Disciplinary','Grievance'])
        const [categoryOptions, setCategoryOptions] = useState(['Minor','Serious','Gross'])
        const [statusOptions, setStatusOptions] = useState(['Open','Reported to HR','Withdrawn','Under Investigation','Resolved','Closed'])
        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_case = () => {
          setmodal_case(!modal_case);
          removeBodyCss();
        }
        const fetchData = async () => {
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRDISCIPLINARYSETUP, JSON.stringify({staffId : userHRId,action:'filter'}), Config)
            setSettings(r.data)
            const edata = {
              id  : '',
              no  : '',
              nin : '',
              name: '',
              phone:'',
              sex : '',
              status:'',
              marital:'',
              dept: '',
              category: '',
              location: ''
             }
            const e = await axios.post(`${url.HREMPLOYEESFILTER}`, JSON.stringify(edata), Config)
            let arr = [];
            (e.data || []).map((a)=>{
              arr.push({'value':a.id, 'label':a.name})
            })
            setEmployeeOptions(arr)
            const data = {
              type:'',
              category:'',
              start_date: formatDate(sStartDate),
              end_date: formatDate(sEndDate),
              action:'filter'
            }
            const c = await axios.post(url.HRDISCIPLINARYCASES, JSON.stringify(data),Config)
            setCases(c.data)
          } catch (e) {
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }
        
        useEffect(() => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
            setUserHRId(obj.hrId)
          }
          fetchData() 
        },[]);

        
        
        const handleFilterData = async () =>{
          const data = {
            id          : '',
            startDate   : formatDate(sStartDate),
            endDate     : formatDate(sEndDate),
            employeeNo  : sEmployeeNo,
            employeeName: sEmployeeName,
            documentNo  : sDocumentNo,
            type        : sType,
            category    : sCategory,
            status      : sStatus,
            staffId     : userHRId,
            action      :'filter'
         }
         try {
          setIsLoading(true)
          const c = await axios.post(url.HRDISCIPLINARYCASES, JSON.stringify(data),Config)
          setCases(c.data)
         } catch (e) {

         } finally {
          setIsLoading(false)
         }
        }
        const handleClearSearch = () =>{
          setPlanId('')
          setSStartDate([new Date()])
          setSEndDate([new Date()])
          setSEmployeeName('')
          setSEmployeeNo('')
          setSDocumentNo('')
          setSType('')
          setSCategory('')
          setSStatus('')
          handleFilterData()
        }

        const handleClickAdd = () =>{
          setIsEdit(false)
          setReportedBy(employeeOptions.find(option => option.value == userHRId))
          console.log(userHRId)
          setInditedStaff(null)
          setDocumentNo('')
          setReportedOn([])
          setIncidentDate([])
          setDescription('')
          setSetupId('')
          setCaseStatus('')
          tog_case()
          
        }
        const handleSaveCase = async() =>{
          const data = {
            id              : isEdit?caseId:'',
            setup_id        : setupId,
            case_description: description,
            reported_on     : formatDate(reportedOn),
            incident_date   : formatDate(incidentDate),
            reported_by     : reportedBy.value,
            indited_staff_id: inditedStaff.value,
            case_status     : caseStatus,
            action          : isEdit?'edit':'add'
          }
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRDISCIPLINARYCASES, JSON.stringify(data), Config)
            if(r.data.status == 1){
                toastr.success(r.data.message)
                tog_case()
                setSetupId('')
                setDescription('')
                setReportedOn([])
                setIncidentDate([])
                setReportedBy(null)
                setInditedStaff(null)
                setCaseStatus('Open')
                handleFilterData()
            }else{
                toastr.error(r.data.message)
            }
          } catch (e) {
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }
        const handleSendToHR = async () =>{
          const data = {case_id: caseId}
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRDISCIPLINARYSEND2HR, JSON.stringify(data), Config)
            if(r.data.status == 1){
              toastr.success(r.data.message)
              tog_case()
              setSetupId('')
              setDescription('')
              setReportedOn([])
              setIncidentDate([])
              setReportedBy(null)
              setInditedStaff(null)
              setCaseStatus('Open')
              handleFilterData()
          }else{
              toastr.error(r.data.message)
          }
          } catch (e) {
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }
        const handleWithdraw = async () =>{
          const data = {case_id: caseId}
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRDISCIPLINARYWITHDRAWCASE, JSON.stringify(data), Config)
            if(r.data.status == 1){
              toastr.success(r.data.message)
              tog_case()
              setSetupId('')
              setDescription('')
              setReportedOn([])
              setIncidentDate([])
              setReportedBy(null)
              setInditedStaff(null)
              setCaseStatus('Open')
              handleFilterData()
          }else{
              toastr.error(r.data.message)
          }
          } catch (e) {
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }

        const pageOptions = {
          sizePerPage: 10000,
          totalSize: cases.length,
          custom: true,
        }
        var node = useRef();
              
        const columns = [
        {
          dataField: 'case_no',
          text: 'No',
          sort: true
        },
        {
          dataField: 'reported_by_name',
          text: 'Reported by',
          sort: true
        },
        {
          dataField: 'indited_staff_name',
          text: 'Indited Staff',
          sort: true
        },
        {
          dataField: 'setup_description',
          text: 'Case',
          sort: true
        }, 

        {
          dataField: 'setup_category',
          text: 'Category',
          sort: true
        }, 
        {
          dataField: 'setup_type',
          text: 'Type',
          sort: true
        }, 
        {
          dataField: 'incident_date',
          text: 'Incident Date',
          sort: true
        }, 
        {
          dataField: 'case_status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'id',
          order: 'desc'
        }];
 
 
        function actionFormatter(cellContent, row){
          return(
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={()=>{ 
                    tog_case();
                    setIsEdit(true)
                    setCaseId(row.id)
                    setReportedBy(employeeOptions.find(option => option.value == row.reported_by))
                    setInditedStaff(employeeOptions.find(option => option.value == row.indited_staff_id))
                    setDocumentNo(row.case_no)
                    setReportedOn([new Date(row.reported_on)])
                    setIncidentDate([new Date(row.incident_date)])
                    setDescription(row.case_description)
                    setSetupId(row.setup_id)
                    setCaseStatus(row.case_status)
                    //console.log(row.case_status)
                    //console.log(employeeOptions.find(option => option.value == row.reported_by))
                    }
                  }
                >
                  Details
            </Button>
          )
        }
        function statusFormatter(cellContent, row) {
          if ((cellContent == "Closed") || (cellContent == "Resolved") ) {
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }else if(cellContent == "Under Investigation"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else if(cellContent == "Withdrawn"){
            return (
              <div>
                  <Badge className="me-2 bg-secondary">{cellContent}</Badge>
              </div>
            );
          }else if(cellContent == "Open"){
            return (
              <div>
                  <Badge className="me-2 bg-dark">{cellContent}</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Disciplinary and Grievances | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                                <Modal isOpen={modal_case} toggle={() => { tog_case(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`} Case</h5>
                                    <button type="button"  onClick={() => { setmodal_case(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                      {isEdit && (
                                      <Col md={12}>
                                        <div className="mb-3">
                                            <label>Document No</label>
                                            <input className='form-control' type='text' defaultValue={documentNo} disabled={true}/>
                                        </div>
                                      </Col>
                                      )}
                                      <Col md={12}>
                                          <div className="mb-3">
                                              <label>Reported By</label>
                                              <Select value={reportedBy} onChange={(oo)=>{setReportedBy(oo);}} options={employeeOptions} isSearchable  isDisabled/>
                                          </div>
                                      </Col>
                                      <Col md={12}>
                                          <div className="mb-3">
                                              <label>Indicted Staff</label>
                                              <Select value={inditedStaff} onChange={(oo)=>{setInditedStaff(oo);}} options={employeeOptions} isSearchable isDisabled={(caseStatus == 'Open')?false:true}/>
                                          </div>
                                      </Col>
                                      <Col md={12}>
                                          <div className="mb-3">
                                              <label>Case Category</label>
                                              <select className="form-select" value={setupId} onChange={(e)=>setSetupId(e.target.value)} disabled={(caseStatus == 'Open')?false:true}>
                                              <option value="">All</option>
                                                  {(settings || []).map((d,k)=>(
                                                  <option key={k} value={d.id}>{d.description}</option>
                                                  ))}
                                              </select>
                                          </div>
                                      </Col>
                                      <Col md={12}>
                                            <div className="mb-3">
                                                <label>Case Description</label>
                                                <textarea className='form-control' value={description} onChange={(e)=>setDescription(e.target.value)} disabled={(caseStatus == 'Open')?false:true}/>
                                            </div>
                                      </Col>
                               
                                      <Col xl={6}>
                                          <div className="mb-3">
                                              <label>Reported On</label>
                                              <Flatpickr
                                                  className="form-control"
                                                  options={{
                                                      dateFormat: "Y-m-d",
                                                      enableTime: false
                                                  }}
                                                  value={reportedOn}
                                                  onChange={(dates)=>{setReportedOn(dates); }}
                                                  disabled={(caseStatus == 'Open')?false:true}
                                                  />
                                          </div>
                                      </Col>
                                      <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Incident Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={incidentDate}
                                                onChange={(dates)=>{setIncidentDate(dates); }}
                                                disabled={(caseStatus == 'Open')?false:true}
                                                />
                                        </div>
                                    </Col>
                                  {isEdit && (
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <select className="form-select" value={caseStatus} onChange={(e)=>setCaseStatus(e.target.value)} disabled={true} >
                                              <option value=""></option>
                                              {statusOptions.map((s,k)=>(
                                                <option key={k} value={s}>{s}</option>
                                              ))}
                                            </select>
                                            
                                        </div>
                                    </Col>
                                )}
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                {caseStatus == 'Open' && (
                                  isLoading ? (
                                    <button type="button" className="btn btn-secondary" disabled>
                                      Please wait...
                                    </button>
                                  ) : (
                                    <button type="button" className="btn btn-success" onClick={handleSaveCase}>
                                      Save...
                                    </button>
                                  )
                                )}

                                {
                                  userHRId == reportedBy?.value && caseStatus == 'Open' && (
                                    isLoading ? (
                                      <button type="button" className="btn btn-secondary" disabled>
                                        Please wait...
                                      </button>
                                    ) : (
                                      <button type="button" className="btn btn-warning" onClick={handleSendToHR}>
                                        Send case to HR
                                      </button>
                                    )
                                  )
                                }
                                {
                                  userHRId == reportedBy?.value && caseStatus == 'Reported to HR' && (
                                    isLoading ? (
                                      <button type="button" className="btn btn-secondary" disabled>
                                        Please wait...
                                      </button>
                                    ) : (
                                      <button type="button" className="btn btn-warning" onClick={handleWithdraw}>
                                        Withdraw case
                                      </button>
                                    )
                                  )
                                }

                                </div>
                                </Modal> 
                     
                        <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter Cases</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                    
                                    </Row>
                                </div>
                                                <Row className="justify-content-center mb-1">
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>Start Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                    dateFormat: "Y-m-d",
                                                                    enableTime: false
                                                                }}
                                                                value={sStartDate}
                                                                onChange={(dates)=>{setSStartDate(dates); }}
                                                                />
                                                        </div>
                                                    </Col>
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>End Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                    dateFormat: "Y-m-d",
                                                                    enableTime: false
                                                                }}
                                                                value={sEndDate}
                                                                onChange={(dates)=>{setSEndDate(dates); }}
                                                                />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="justify-content-center mb-2">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Employee No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sEmployeeNo} onChange={(e)=>setSEmployeeNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Employee Name</label>
                                                          <input type='text' className="form-control form-control-sm" value={sEmployeeName} onChange={(e)=>setSEmployeeName(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Document No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sDocumentNo} onChange={(e)=>setSDocumentNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Case Type</label>
                                                          <select className="form-select form-select-sm" value={sType} onChange={(e)=>setSType(e.target.value)}>
                                                          <option value="">All</option>
                                                             {( typeOptions|| []).map((d,k)=>(
                                                              <option key={k} value={d}>{d}</option>
                                                             ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Case Category</label>
                                                          <select className="form-select form-select-sm" value={sCategory} onChange={(e)=>setSCategory(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(categoryOptions || []).map((d,k)=>(
                                                                <option key={k} value={d}>{d}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(statusOptions || []).map((e,k)=>(
                                                                <option value={e} key={k}>{e}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                          
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                        
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Report Case
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Staff Grievances ({cases.length})</h5>
                                                  <CardBody>

                                                                                             
                                {(cases.length > 0) && (
                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="id"
                                    columns={columns}
                                    data={cases}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ cases }
                                      columns={ columns }
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  
                                                  keyField='id' 
                                                  data={ cases } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  style={{ backgroundColor: 'white' }}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                                  </div>
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {((cases || []).length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No Case reported</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        onClick={()=>{handleClickAdd()}}
                                       
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Report case <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default PersonalDisciplinaryAndGrievances;